export default __webpack_public_path__ + "static/media/dropdown-indicator.e844511e.svg";